import { Component, OnInit, NgModule, TemplateRef, signal } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import * as _moment from 'moment';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { AppComponent } from '../app.component';
import Swal from 'sweetalert2';
import { Modal } from 'bootstrap';
import { filter } from 'rxjs/operators';
import { PendingThings } from '../dashboard/dashboard/dashboard.component';
declare var $: any;
export class TodayAlertData {
  Title: string;
  Value: any;
  Link: string;
}

export class TodayAlertDataFinalVerdict {
  Title: string;
  Value: any;
  Link: string;
}

export class TodayAlertDataMyFeedBack {
  Title: string;
  Value: any;
  Link: string;
}


@Component({
  selector: 'app-master-page',
  templateUrl: './master-page.component.html',
  styleUrls: ['./master-page.component.css'],
  standalone: false
})
export class MasterPageComponent implements OnInit {
  url: string;
  cID: string;
  modelName: string;
  ModelForMaster: any;
  ModuleMasterData: any;
  modalURL: string;
  CallFunctionOnCloseModal: any;
  UserName: string;
  PageUrl: string;
  modalURLCommunity: string;
  ModelForCommunity: string;
  logo: string;
  DownloadURL: string;
  MasterMenu: any;
  CallFunctionOnCloseModalCommunity: any;
  UserID: any;
  height: string;
  width: string;
  TodayAlert: string;
  AlertLink: string;
  CompanyName: string;
  TodayAlertFinalVerdict: string;
  TodayAlertMyFeedBack: string;
  MyFeedBack: string;
  AlertLinkFinalVerdict: string;
  AlertLinkMyFeedBack: string;
  PendingFinalVerdict: string;
  PendingSeniorFeedBack: string;
  IsCompleted: string;
  Role: any;
  email: string;
  ReportData: any = null;
  ModuleData: any = null;
  MsgType: number;
  ReportUrl: string;
  FlowData: any = null;
  ModelFor: any;
  RadioValue: any;
  isModalPopUp: boolean = false;
  activeRoute: string;
  selectedMenu: string = '';
  sidebarExpanded = signal(true);
  PendingMyFeedBack: string;
  PendingDiary: string;
  PendingCase: string;
  PendingNotice: string;
  PendingDecision: string;

  constructor(private router: Router, private http: HttpClient, private sanitization: DomSanitizer, private route: ActivatedRoute) {
    this.url = AppComponent.baseURL; this.DownloadURL = AppComponent.DownloadURL;
  }

  ngOnInit() {
      this.route.url.subscribe(() => {
        this.activeRoute = this.router.url;
      });
    if (localStorage.getItem('xVal') == null || localStorage.getItem('xVal') === '' ||
      localStorage.getItem('LoginID') == null || localStorage.getItem('LoginID') === '') {
      this.router.navigate(['/login']);
    }
    this.alertData();
    this.AlertDataFinalVerdict();
    this.AlertMyFeedBack();
    this.PendingThings();
    this.MasterMenu = 1;
    this.email = localStorage.getItem('email');
    this.UserID = localStorage.getItem('LoginID');
    this.PageUrl = this.router.url;
    this.UserName = localStorage.getItem('UserName');
    this.Role = localStorage.getItem('Role');
    this.CompanyName = localStorage.getItem('CommunityCode');
    this.logo = localStorage.getItem('Logo') == "" ? "assets/resources/images/Redleaf.png" : this.DownloadURL + "Attachment/" + localStorage.getItem('CommunityCode') + "/" + localStorage.getItem('Logo');
    this.OpenModal(105, "Notice Reports");
  }

  isActive(path: string): boolean {
    return this.activeRoute?.startsWith(path) ?? false;
  }

  toggleSidebar() {
    if(this.sidebarExpanded()){
      document.getElementById('quickActions')?.classList?.remove('show');
      document.getElementById('notice')?.classList?.remove('show');
      document.getElementById('case')?.classList?.remove('show');
      document.getElementById('finalVerdict')?.classList?.remove('show');
      document.getElementById('diary')?.classList?.remove('show');
      document.getElementById('DecisionReports')?.classList?.remove('show');
      document.getElementById('Report')?.classList?.remove('show');
    }
    this.sidebarExpanded.update(v => !v);
}
  logoutConfirmation() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'you want to logout from your account?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.value) {
        this.confirmLogout();
      }
    })
  }
  confirmLogout() {
    localStorage.setItem('xVal', '');
    localStorage.setItem('LoginUserID', '');
    localStorage.setItem('LoginID', '');
    localStorage.setItem('UserRight', '');
    localStorage.setItem('Role', '');
    localStorage.setItem('UserName', '');
    localStorage.setItem('Users', '');
    localStorage.setItem('Company', '');
    localStorage.setItem('Logo', '');
    localStorage.setItem('CommunityCode', '');
    this.router.navigate(['/login']);
  }
  OpenModalMaster(cID, modelName) {
    this.ModelForMaster = modelName;
    this.http.get(this.url + 'Dashboard/GetDashboardModule?GenID=' + cID)
      .subscribe((data) => {
        if (data == null) {
          this.ModuleMasterData = null;
        } else {
          this.ModuleMasterData = JSON.parse(data.toString());
        }
      }
      );
  }
  CallFunctionOnClose() {
    window.location.reload();
  }
  OpenModalIFrameCommunity() {
    this.height = "490 px";
    this.width = "60";
    this.modalURLCommunity = "community";
    this.ModelForCommunity = "Community Profile";
    this.CallFunctionOnCloseModalCommunity = "CallFunctionOnClose";
  }
  OpenModalPass(url, modelName) {
    this.height = "290 px";
    this.width = "60";
    let myDate = Math.floor(Math.random() * 6) + 1;
    this.modalURLCommunity =  url + "/" + this.UserID;
    this.ModelForCommunity = modelName;
    this.CallFunctionOnCloseModalCommunity = "CallFunctionOnClose";
  }
  OpenModalProfile(url, modelName) {
    this.height = "500 px";
    this.width = "70";
    let myDate = Math.floor(Math.random() * 6) + 1;
    this.modalURLCommunity =  url + "/" + this.UserID;
    this.ModelForCommunity = modelName;
    this.CallFunctionOnCloseModalCommunity = "CallFunctionOnClose";
  }

  alertData() {
    this.http.get(this.url + 'Dashboard/Dashboard_Alert_Data')
      .subscribe((data) => {
        if (data == null) { } else {
          let todayAlertData: TodayAlertData[] = JSON.parse(data.toString());
          this.TodayAlert = todayAlertData[0]["Value"].toString();
          this.AlertLink = todayAlertData[0]["Link"].toString();
        }
      }
      );
  }

  AlertDataFinalVerdict() {
    this.http.get(this.url + 'Dashboard/FinalVerdict_Report_Dashboard_Summary')
      .subscribe((data) => {
        if (data == null) { } else {
          let todayAlertDataFinalVerdict: TodayAlertDataFinalVerdict[] = JSON.parse(data.toString());
          this.TodayAlertFinalVerdict = todayAlertDataFinalVerdict[0]["Value"].toString();
          this.AlertLinkFinalVerdict = todayAlertDataFinalVerdict[0]["Link"].toString();
        }
      }
      );
  }

  AlertMyFeedBack() {
    this.http.get(this.url + 'Dashboard/Dashboard_PendingFeedback_BellIcon')
      .subscribe((data) => {
        if (data == null) { } else {
          let todayAlertDataMyFeedBack: TodayAlertDataMyFeedBack[] = JSON.parse(data.toString());
          this.TodayAlertMyFeedBack = todayAlertDataMyFeedBack[0]["Value"].toString();
          this.AlertLinkMyFeedBack = todayAlertDataMyFeedBack[0]["Link"].toString();
        }
      }
      );
  }

  OpenFlow(GenID: string, FlowID: string, Link: string, type: any, Name: string): void {
    this.isModalPopUp = true;
    this.MsgType = type;
    this.ReportUrl = Link;
    this.ModelFor = Name;

    this.http.get(this.url + 'Dashboard/GetFlow?GenID=' + GenID + '&FlowID=' + FlowID)
      .subscribe((data) => {
        if (data == null) {
          this.FlowData = null;
        } else {
          this.FlowData = JSON.parse(data.toString());
        }

        // Handle special cases with new tab navigation
        if (this.ReportUrl === "report/207084000/0/0/0/") {
          this.navigateToReportNewTab('/report/207084000/0/0/0/32/HLPNoticeType~2');
        } else if (this.ReportUrl === "report/207089000/0/0/0/") {
          this.navigateToReportNewTab('/report/207089000/0/0/0/56/HLPNoticeType~2');
        }
      });
  }

  // Method to navigate to report in new tab
  navigateToReportNewTab(route: string): void {
    const url = this.router.createUrlTree([route]).toString();
    window.open(url);
  }


  OpenModal(cID, modelName) {

    this.ModuleData = null;
    // this.ModelFor = modelName;//
    if (cID == 110) {
      this.MsgType = 6;
      this.http.get(this.url + 'Dashboard/GetDashboardReport?GenID=' + cID)
        .subscribe((data) => {
          if (data == null) {
            this.ReportData = null;
          } else {
            this.ReportData = JSON.parse(data.toString());
          }
        }
        );
      this.http.get(this.url + 'Dashboard/GetDashboardModuleData?GenID=' + cID)
        .subscribe((data) => {
          if (data == null) {
            this.ModuleData = null;
          } else {
            this.ModuleData = JSON.parse(data.toString());
          }
        }
        );
    }
    else if (cID == 105) {
      this.MsgType = 1;
      this.http.get(this.url + 'Dashboard/GetDashboardReportModule?GenID=' + cID)
        .subscribe((data) => {
          if (data == null) {
            this.ReportData = null;
          } else {
            this.ReportData = JSON.parse(data.toString());
          }
        }
        );
    }
    else {
      this.MsgType = 0;
      this.http.get(this.url + 'Dashboard/GetDashboardModule?GenID=' + cID)
        .subscribe((data) => {

          if (data == null) {
            this.ModuleData = null;
          } else {
            this.ModuleData = JSON.parse(data.toString());
          }
        }
        );
    }
  }

  onItemChange(value) {
    this.RadioValue = value;
  }

    PendingThings() {
      this.http.get(this.url + 'Dashboard/Dashboard_Pending_All_Things')
        .subscribe((data) => {
          if (data == null) {
            const pendingThings: PendingThings = null;
          } else {
            const pendingThings: PendingThings = JSON.parse(data.toString())[0];
            this.PendingSeniorFeedBack = pendingThings.PendingSeniorFeedBack;
            this.PendingMyFeedBack = pendingThings.PendingMyFeedBack;
            this.PendingDiary = pendingThings.PendingDiary;
            this.PendingCase = pendingThings.PendingCase;
            this.PendingNotice = pendingThings.PendingNotice;
            this.PendingDecision = pendingThings.PendingDecision;
            this.PendingFinalVerdict = pendingThings.PendingFinalVerdict;
          }
        }
        );
    }
}

